module.exports = __webpack_public_path__ + "img/image14.b84afd39.png";